export enum LandStatus {
    UNKNOWN = 0,
    IZHS = 1,
    SNT = 2,
    DNP = 3,
    INDUSTRIAL = 4,
    AGRICULTURAL = 5,
    INVEST = 6,
}
